import _trim from "lodash/trim";
import _map from "lodash/map";
import _join from "lodash/join";
export default (function () {
  for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }

  return _join(_map(paths, function (path) {
    return _trim(encodeURI(path), '/');
  }), '/');
});